/**
 * 알림 REST 호출 (Shell 전속) — pf-hermes (F-03 §7.4·§7.5).
 * 소유: 프레임 팀.
 *
 * - 미읽음 카운트: GET /api/hermes/notifications/unread-count?memberId=  (초기·재동기화)
 * - 읽음 처리:    PATCH /api/hermes/notifications/{id}/read
 *
 * 상태 원본은 REST(DB), SSE 는 증분 트리거 (C-04 §9.3). 배지 진실값은 항상 REST 로 복구한다.
 */
import { apiClient } from '@indipia/shared';

/** ApiResponse<T> → data 언래핑 */
function unwrap<T>(res: { data?: { data?: T } }): T | undefined {
  return res?.data?.data;
}

export async function fetchUnreadCount(memberId: number): Promise<number> {
  const res = await apiClient.get('/hermes/notifications/unread-count', {
    params: { memberId },
  });
  const payload = unwrap<{ memberId: number; count: number }>(res);
  return payload?.count ?? 0;
}

export async function markNotificationRead(id: number): Promise<void> {
  await apiClient.patch(`/hermes/notifications/${id}/read`);
}

/**
 * [DEV/발신측 대역] 알림 생성 — POST /api/hermes/notifications
 *
 * 정식 체계에서는 각 에이전트 BE 가 호출(F-03 §5.1). 현재 발신측 미구현이라
 * FE 가 발신 대역으로 직접 호출한다. X-Source-Agent 는 발신 에이전트 코드(TM_AGENT.AGENT_CODE).
 * X-User-Id(트리거 행위자)는 정식 체계에선 게이트웨이가 JWT 에서 주입 → 여기선 생략.
 */
export interface CreateNotiInput {
  sourceAgent: string;   // X-Source-Agent (A01·A02·E01 등)
  memberId: number;      // 수신자 회원ID
  notiType: string;
  title: string;
  body: string;
  targetType?: string;
  targetId?: number;
  linkUrl?: string;
}

export async function createNotification(input: CreateNotiInput): Promise<void> {
  await apiClient.post(
    '/hermes/notifications',
    {
      memberId: input.memberId,
      notiType: input.notiType,
      title: input.title,
      body: input.body,
      targetType: input.targetType ?? null,
      targetId: input.targetId ?? null,
      linkUrl: input.linkUrl ?? null,
    },
    { headers: { 'X-Source-Agent': input.sourceAgent } },
  );
}
